import { useCallback } from 'react';
import { useTranslation } from '../components/feature/TranslationProvider';

/**
 * Hook that returns a click handler to open the Datadrivers privacy policy in a new tab.
 * Tries window.open, falls back to window.location if blocked (e.g., Safari popup blocker).
 * @returns {function} onClick handler
 */
const useOpenPrivacyPolicy = () => {
  const { lang } = useTranslation();
  const policyUrls = {
    fi: 'https://datadrivers.fi/tietosuojaseloste/',
    en: 'https://datadrivers.fi/en/privacy-policy/',
    se: 'https://datadrivers.fi/sv/dataskyddsbeskrivning/',
  };
  const policyUrl = policyUrls[lang] || policyUrls['en'];

  return useCallback(() => {
    const opened = window.open(policyUrl, '_blank', 'noopener');
    if (!opened) {
      // Fallback for Safari and popup blockers.
      window.location.href = policyUrl;
    }
  }, [policyUrl]);
};

export default useOpenPrivacyPolicy;
